import { render, staticRenderFns } from "./imageClippingPopover.vue?vue&type=template&id=042ea346&"
import script from "./imageClippingPopover.vue?vue&type=script&lang=js&"
export * from "./imageClippingPopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/builds/MWmsPKDH/0/framework/qmai-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('042ea346')) {
      api.createRecord('042ea346', component.options)
    } else {
      api.reload('042ea346', component.options)
    }
    module.hot.accept("./imageClippingPopover.vue?vue&type=template&id=042ea346&", function () {
      api.rerender('042ea346', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/qm-picture-library/src/components/imageClippingPopover.vue"
export default component.exports